export const environment = {
  production: false,
  backendApiUrl: 'https://hsm-api-dev.labcorp.com',
  oktaClientId: '0oa24h2yddgg9TzVf0h8',
  oktaIssuer: 'https://login-dev.labcorp.com/oauth2/default',
  oktaRedirectUri: 'https://hsm-dev.labcorp.com/auth/login',
  post_logout_redirect_uri: 'https://hsm-dev.labcorp.com/auth/logout'
};
